import { useQuery } from "@apollo/client/react";
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { constantsData } from "@/data";
import { getReleasesVideosSelectionListQuery } from "@/graph";
import { openAlert } from "@/redux/actions";
import { displayErrorHandler } from "@/utils";

const useReleasesVideosSelectionList = (releasesIds = []) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const ids = releasesIds.filter(Boolean).map((releaseId) => parseInt(releaseId));

    const { data, error, loading } = useQuery(getReleasesVideosSelectionListQuery, {
        skip: !isAuthenticated || ids.length === 0,
        variables: { releasesIds: ids },
    });

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(t("messages.networkFailure"), dispatch, openAlert);
            }
        },
        [error, data], // eslint-disable-line
    );

    // videos with no ISRC of their own are still listed, falling back to the parent track's title/ISRC,
    // so the gap is visible instead of silently dropped
    const options =
        data?.listVideos?.posts?.map(({ id, isrc: videoIsrc, name, release_id: videoReleaseId, track }) => {
            const isrc = videoIsrc || track?.isrc || "";

            return {
                isrc,
                label: isrc ? `${track?.title || name} - ${isrc}` : track?.title || name,
                releaseId: videoReleaseId,
                value: id,
            };
        }) || [];

    return {
        error,
        loading,
        options,
    };
};

export default useReleasesVideosSelectionList;
